import {  Button } from 'react-bootstrap';
import React, { useState } from 'react';

const DepartmentTree = ({ departments, onEdit, onDelete }) => {
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState(() => {
    const expanded = {};
    departments.forEach(dept => {
      expanded[dept.id] = true;
    });
    return expanded;
  });

  const buildTree = (items, parentId = null) => {
    return items
      .filter(item => {
        if (parentId === null) {
          return !item.parent_id || item.parent_id === "";
        }
        return item.parent_id === parentId;
      })
      .map(item => ({
        ...item,
        children: buildTree(items, item.id)
      }));
  };

  const toggleNode = (nodeId) => {
    setExpandedNodes(prev => ({
      ...prev,
      [nodeId]: !prev[nodeId]
    }));
  };
  const handleEdit = (node) => {
    setSelectedNodeId(node.id);
    onEdit(node);
  };

  const renderTree = (nodes, level = 0) => {
    return nodes.map(node => (
      <div 
       key={node.id} 
       className="department-node" 
       style={{ 
         marginLeft: `${level * 20}px`
       }}
     >
        <div className="d-flex align-items-center p-1"
         style={{ 
          backgroundColor: selectedNodeId === node.id ? '#e9ecef' : 'transparent'
        }}
        >
          {node.children && node.children.length > 0 && (
            <i
              className={`bi bi-chevron-${expandedNodes[node.id] ? 'down' : 'right'} me-2`}
              onClick={(e) => {
                e.stopPropagation();
                toggleNode(node.id);
              }}
              style={{ cursor: 'pointer' }}
            />
          )}
          <span onClick={() => handleEdit(node)}>{node.name}</span>
          <div className="ms-auto">
            <Button variant="link" size="sm" className="me-2" onClick={() => handleEdit(node)}>
              <i className="bi bi-pencil"></i>
            </Button>
            <Button variant="link" size="sm" onClick={() => onDelete(node.id)}>
              <i className="bi bi-trash"></i>
            </Button>
          </div>
        </div>
        {node.children && node.children.length > 0 && expandedNodes[node.id] && (
          <div>{renderTree(node.children, level + 1)}</div>
        )}
      </div>
    ));
  };

  const treeData = buildTree(departments);
  return <div className="department-tree">{renderTree(treeData)}</div>;
};

export default DepartmentTree;